import { render, staticRenderFns } from "./fr4Form.vue?vue&type=template&id=6aad601f&scoped=true"
import script from "./fr4Form.vue?vue&type=script&lang=js"
export * from "./fr4Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aad601f",
  null
  
)

export default component.exports